var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDcDialLogoEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 52,
    viewBox: "0 0 187 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_256_4098)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.2626 23.0799C79.809 22.7586 81.2695 23.4305 82.2145 24.4822C84.1332 26.7316 84.5055 36.0799 79.179 36.5474C72.5638 37.1608 72.2202 24.3069 78.2626 23.0799ZM83.3313 20.3631C82.9591 19.8372 81.3268 18.0552 78.6349 17.6462C76.4585 17.2957 73.5661 17.9676 71.9911 19.0777C62.9418 25.4462 66.4355 45.1653 78.8067 41.7766C81.2695 41.1047 83.0736 38.9429 83.2741 38.6215L83.3313 41.426L90.2329 41.4552V6.9541H83.3313V20.3631Z",
    fill: "#848182"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.472 30.3247C169.446 35.0573 165.15 39.0595 162.086 36.2258C160.654 34.882 160.998 32.4573 162.63 31.4932C163.432 31.0258 167.327 30.3831 168.472 30.3247ZM157.132 19.4281L157.046 24.6281C158.134 24.1022 158.048 24.1607 159.852 23.3719C160.883 22.9337 162.143 22.5831 163.375 22.4663C166.324 22.2326 168.615 22.8753 168.558 26.0887C166.611 27.1112 161.599 26.7899 159.022 28.046C150.144 32.3696 156.13 45.8371 165.322 41.2213C167.327 40.2281 167.269 39.4101 168.558 38.3584L168.615 41.3966H175.03C175.03 37.7449 175.03 34.1225 175.03 30.4708C175.03 26.7022 175.345 23.7517 173.541 21.0056C170.305 16.0977 161.771 17.2663 157.132 19.4281Z",
    fill: "#848182"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.772 40.5494L112.801 35.0865C111.684 35.1741 108.992 37.5404 105.384 36.1966C97.7378 33.3921 101.718 19.282 111.226 23.8101C111.799 24.0438 112.114 24.2191 112.801 24.482V18.6977C109.107 16.8573 103.379 17.1786 99.7997 19.3697C93.0413 23.518 91.9817 35.6123 99.7424 40.4618C102.892 42.4483 109.594 42.7696 112.772 40.5494Z",
    fill: "#848182"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.097 41.3677H186.97L186.941 6.9834H180.097V41.3677Z",
    fill: "#848182"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.187 41.3675H151.174V18.2305H144.187C144.187 21.5608 144.187 39.644 144.187 41.3675Z",
    fill: "#848182"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5715 0.0302734L48.8534 2.07522L37.6563 13.6438H13.458L2.28955 2.07522L25.5715 0.0302734Z",
    fill: "#FDD12F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5715 51.9135L2.28955 49.9269L13.458 38.3584H37.6563L48.8534 49.9269L25.5715 51.9135Z",
    fill: "#39C84F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.113281 26.001L2.2897 2.0752L13.4581 13.6437V38.3583L2.2897 49.9269L0.113281 26.001Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.972 26.001L48.8529 2.0752L37.6558 13.6437V38.3583L48.8529 49.9269L50.972 26.001Z",
    fill: "#C51F25"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.651 14.2861C149.599 14.2861 151.174 12.6794 151.174 10.6929C151.174 8.70635 149.599 7.09961 147.651 7.09961C145.704 7.09961 144.129 8.70635 144.129 10.6929C144.129 12.6794 145.704 14.2861 147.651 14.2861Z",
    fill: "#848182"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.977 23.0799C128.523 22.7586 129.984 23.4305 130.929 24.4822C132.847 26.7316 133.22 36.0799 127.893 36.5474C121.249 37.1608 120.906 24.3069 126.977 23.0799ZM132.017 20.3631C131.645 19.8372 130.012 18.0552 127.32 17.6462C125.144 17.2957 122.252 17.9676 120.677 19.0777C111.627 25.4462 115.121 45.1653 127.492 41.7766C129.955 41.1047 131.759 38.9429 131.988 38.6215L132.046 41.426L138.947 41.4552V6.9541H132.017V20.3631Z",
    fill: "#848182"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clip-path", {
    id: "clip0_256_4098"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 187,
    height: 52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcDialLogoEn);
export default __webpack_public_path__ + "static/media/DCDialLogoEn.b5776e49a03b34b17f036d3fc53b3630.svg";
export { ForwardRef as ReactComponent };